// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".statusEmoji[data-v-2cdbd54d]{padding-right:.4rem}.menuIcon[data-v-2cdbd54d],.statusEmoji[data-v-2cdbd54d]{font-size:1rem;width:1.5rem;height:1.5rem}.menuIcon[data-v-2cdbd54d]{padding-right:.5rem;color:#000}.menuText[data-v-2cdbd54d]{align-self:center;color:#4d4d4d;flex:0 0 auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
